import useCityProfitsHeaderLogic from './cityProfitsHeaderLogic.js';

function CityProfitsHeader(props) {
  const { itemsSelected, setItemsSelected } = props;
  const {
    //STATES
    input,
    itemSelected,
    hideItemList,
    disableButton,
    //VARIABLES
    filteredSearches,
    sortedSearches,
    //FUNCTIONS
    searchItem,
    selectItem,
    handleSearch,
  } = useCityProfitsHeaderLogic(itemsSelected, setItemsSelected);

  return (
    <div className="cityProfitsHeader">
      <div className="searchInputContainer">
        <input
          className={'searchInput'}
          onChange={e => searchItem(e.target.value)}
          value={input}
          placeholder={' Search an Item'}
        />
        <div
          className={`selectSearch ${input === '' && 'hidden'} ${
            hideItemList && 'hidden'
          }`}
        >
          {filteredSearches.length >= 1 &&
            sortedSearches.map((item) => (
              <p
                className={`selectOptions`}
                onClick={() => {
                  selectItem(item);
                }}
              >
                {item.itemName}
              </p>
            ))}
        </div>
      </div>


      <button
        className={'searchButton'}
        disabled={disableButton}
        onClick={() => {
          handleSearch(itemSelected);
        }}
      >
        Search
      </button>
    </div>
  );
}

export default CityProfitsHeader;
